import { inject, Injectable } from "@angular/core";
import { UpdateSmeSelectionResultsSummaryPwc, UpdateSmeSelectionResultSw } from "./eea-output-project.interface";
import { EEAOutputProjectApiService } from "./eea-output-project.api.service";
import { lastValueFrom, take } from "rxjs";
import { RowSelectedEvent } from "ag-grid-community";
import { GridComponent } from "src/app/shared/components/grid/grid.component";

@Injectable({
  providedIn: 'root'
})

export class EEAOutputProjectLogicService {

  private apiService = inject(EEAOutputProjectApiService);

  public async updateSmeSelectionResultsSw(smeSelections: UpdateSmeSelectionResultSw[]): Promise<boolean> {
    const source$ = this.apiService.updateSmeSelectionResultsSw(smeSelections).pipe(take(1));
    const result = await lastValueFrom(source$);
    return result;
  }

  public setSmeSelectionResultsSw( event: RowSelectedEvent ){
    const { node } = event;
    const { data, selected } = node as any;
    const { ResultsSurfaceWaterPk } = data;
    const smeSelection: UpdateSmeSelectionResultSw ={
      resultSurfaceWaterPk: ResultsSurfaceWaterPk,
      smeSelectionValue: selected,
    }
    this.updateSmeSelectionResultsSw( [smeSelection] );
  }

  public setSmeSelectionResultSummaryPwc( event: RowSelectedEvent ){
    const { node } = event;
    const { data, selected } = node as any;
    const { ResultsSummaryPK } = data;
    const smeSelection: UpdateSmeSelectionResultsSummaryPwc ={
      ResultsSummaryPK: ResultsSummaryPK,
      smeSelectionValue: selected,
    }
    this.updateSmeSelectionResultSummaryPwc( [smeSelection] );
  }

  public async updateSmeSelectionResultSummaryPwc(smeSelections: UpdateSmeSelectionResultsSummaryPwc[]): Promise<boolean> {
    const source$ = this.apiService.updateSmeSelectionResultSummaryPwc(smeSelections).pipe(take(1));
    const result = await lastValueFrom(source$);
    return result;
  }

  public setSmeSelectionsResultsSw( grid: GridComponent ): void {
    const smeSelections: UpdateSmeSelectionResultSw[] = [];

    grid.gridApi.forEachNode((node: any) => {
      const { data, selected} = node;
      smeSelections.push({
        resultSurfaceWaterPk: data.ResultsSurfaceWaterPk,
        smeSelectionValue: selected
      });
    });

    this.updateSmeSelectionResultsSw( smeSelections );
  }

  public setSmeSelectionsResultSummaryPwc( grid: GridComponent ): void {
    const smeSelections: UpdateSmeSelectionResultsSummaryPwc[] = [];

    grid.gridApi.forEachNode((node: any) => {
      const { data, selected} = node;
      smeSelections.push({
        ResultsSummaryPK: data.ResultsSummaryPK,
        smeSelectionValue: selected
      });
    });

    this.updateSmeSelectionResultSummaryPwc( smeSelections );
  }

}
